import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import intl from 'react-intl-universal'
import Popup from 'react-popup'
import { connect } from 'react-redux'
import { sendData } from '../actions/RmaActions'
import { logUserOut } from '../actions/AuthActions'
import Images from './Images'
import Files from './Files'
import ProductListItem from './ProductListItem'

const mapStateToProps = state => ({
  authenticated: state.auth.session.id !== false,
  order: state.rma.order,
  lang: state.auth.lang,
  reasons: state.config.reasons,
})

const mapDispatchToProps = dispatch => ({
  sendDataAction: (data) => dispatch(sendData(data)),
  logUserOutAction: () => dispatch(logUserOut()),
})

class OrderComponent extends React.Component {
  constructor(props) {
    super(props)
    this.lines = []
    this.state = {
      valid: false,
      image_ids: [],
      pdf_ids: [],
      note: '',
      show_bank: false,
      return_bank_account: '',
      return_address: '',
      validAcc: false,
      orderLogoUrl: '',
      form_choose: null,
    }
    this.logoRequestId = 0
  }

  componentDidMount() {
    this.resolveOrderLogo()
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.order && prevProps.order.shop) !== (this.props.order && this.props.order.shop)) {
      this.resolveOrderLogo()
    }
  }

  componentWillUnmount() {
    this.logoRequestId += 1
  }

  noteChange = (event) => {
    this.setState({note: event.target.value})
  }

  handleChange = (event) => {
    const {target} = event
    let self = this
    this.setState({
      [target.name]: target.value
    }, () => {
      self.toggleConfirmButton()
    })
  }

  getProductListItem = (product, i, form_choose) => (
    <ProductListItem key={product.id}
                     childIndex={i}
                     product={product}
                     form_choose={form_choose}
                     parent={this}/>
  )

  logUserOut = (event) => {
    const {logUserOutAction} = this.props
    logUserOutAction()
  }

  collectData = () => {
    const {lines} = this
    const {order} = this.props
    const {
      note,
      image_ids,
      pdf_ids,
      show_bank,
      return_bank_account,
      return_address,
      form_choose,
    } = this.state
    let result = {
      order_id: order.id,
      lines: [],
      note,
      submission_type: form_choose === 'withdrawal' ? 'withdrawal' : 'return',
    }
    const withdrawalReason = this.props.reasons.find(r => r.is_withdrawal)
    result.lines = lines.map(line => {
      const { checked, reason, expectation, note, agree } = line.state
      for (let key in checked){
        if(typeof note[key] === 'undefined'){
          note[key] = ''
        }
      }
      const { product } = line.props
      console.log(this.props.reasons)
      const withdrawalReason = this.props.reasons.find(
          r => r.is_withdrawal
        )
      console.log(withdrawalReason)
      return {
        id: product.id,
        checked,
        reason: form_choose === 'withdrawal' && withdrawalReason
          ? Object.keys(checked).reduce((acc, k) => ({ ...acc, [k]: String(withdrawalReason.id) }), {})
          : reason,
        expectation,
        agree,
        note: note
      }
    })
    result.images = image_ids.map(id => { return [4, id, false] })
    result.files = pdf_ids.map(id => {return [4, id , false] })
    if(show_bank){
      result.return_bank_account = return_bank_account
      result.return_address = return_address
    }
    return result
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { form_choose, return_bank_account } = this.state
    if (form_choose === 'withdrawal' && return_bank_account === '') {
      Popup.create({
        className: 'bank-confirm',
        content: intl.get('Nie podałeś danych rachunku bankowego do zwrotu środków. Jeżeli zwrot będzie realizowany przelewem, brak tych danych może opóźnić jego realizację. Czy na pewno chcesz kontynuować bez podania numeru rachunku?'),
        buttons: {
          right: [{
            text: intl.get('Kontynuuj bez numeru rachunku'),
            key: 'enter',
            className: 'cancel-button',
            action: () => {
              Popup.close()
              this.submitForm()
            }
          },
          {
            text: intl.get('Wróć i uzupełnij dane'),
            action: () => {
              Popup.close()
            }
          }]
        }
      })
      return
    }
    this.submitForm()
  }

  submitForm = () => {
    const { sendDataAction } = this.props
    sendDataAction(this.collectData())
  }

  validAcc = (nr) => {
    return /\d{10}/.test(nr.replaceAll(' ', ''))
  }

  toggleConfirmButton = () => {
    let state = {}
    const {
      valid,
      return_bank_account,
      return_address,
      validAcc,
      show_bank
    } = this.state
    const isWithdrawal = this.state.form_choose === 'withdrawal'
    if (isWithdrawal) {
      state.show_bank = true
      const hasProduct = this.lines.some(line =>
        Object.values(line.state.checked).some(v => v === true)
      )

      state.validAcc = true

      if(return_bank_account !== '') {
        state.validAcc = this.validAcc(return_bank_account)
      }
      let info = document.querySelector('.accInvalid')
      if(info){
        if(state.validAcc){
          info.classList.add('hidden')
        } else {
          info.classList.remove('hidden')
        }
      }

      state.valid = hasProduct && state.validAcc

      this.setState(state)
      return
    }
    const {lines} = this
    const {reasons} = this.props
    state.show_bank = false

    const validArr = lines.map(line => {
      let {checked, reason, agree} = line.state
      if (!Object.keys(checked).some(c => checked[c])){ return undefined } //line niezaznaczony
      let checked_indexes = Object.keys(checked).filter(i => (checked[i] === true))
      if (checked_indexes.some(i => ( //jeden z niezaznaczonych nie ma reason
          typeof reason[i] === 'undefined'
        ))){
          return false
      }

      let display_bank_account = false
      let confirmed = true
      Object.keys(checked).map(i => {
        if (checked[i] !== true){ return false }
        let r = reason[i]
        if (typeof r === 'undefined'){ return false }
        let a = agree[i]
        let rd = reasons.find(rd => {
          return rd.id === parseInt(r)
        })
        if (rd.display_bank_account === true){
          display_bank_account = true
        }
        if(rd.optional_note && rd.must_confirm){
          if(a !== true){ confirmed = false }
        }
      })
      if(display_bank_account){
        state.show_bank = true
      }
      if(!confirmed){ return false }
      return true
    })
    if(validArr.every(v => (v || typeof v === 'undefined')) && validArr.some(v => v)){
      state.valid = true
    } else {
      state.valid = false
    }
    state.validAcc = true
    if(state.show_bank){
      if(return_bank_account !== '') {
        state.validAcc = this.validAcc(return_bank_account)
      }
      let info = document.querySelector('.accInvalid')
      if(info){
        if(state.validAcc){
          info.classList.add('hidden')
        } else {
          info.classList.remove('hidden')
        }
      }
    }
    state.valid = state.valid && state.validAcc
    if(state.valid !== valid || state.show_bank !== show_bank || state.validAcc !== validAcc){
      this.setState(state)
    }
  }

  getOrderLogoStyle = () => {
    const { orderLogoUrl } = this.state
    if (!orderLogoUrl) {
      return ''
    }
    if (orderLogoUrl === '__loading__') {
      return '#root header .logo{background-image:none}'
    }
    return `#root header .logo{background-image:url("${orderLogoUrl}")}`
  }

  resolveOrderLogo = () => {
    const { order } = this.props
    if (!order || !order.shop) {
      if (this.state.orderLogoUrl !== '') {
        this.setState({ orderLogoUrl: '' })
      }
      return
    }
    const conf = window.ODOO || {}
    const odooBaseUrl = `${conf.url || ''}${conf.port ? `:${conf.port}` : ''}`
    const shopLogoUrl = `${odooBaseUrl}/sale_shop/logo?name=${encodeURIComponent(order.shop)}`
    const defaultLogoUrl = `${odooBaseUrl}/web/binary/company_logo`
    const requestId = this.logoRequestId + 1
    this.logoRequestId = requestId
    this.setState({ orderLogoUrl: '__loading__' })
    const img = new Image()
    img.onload = () => {
      if (this.logoRequestId !== requestId) return
      this.setState({ orderLogoUrl: shopLogoUrl })
    }
    img.onerror = () => {
      if (this.logoRequestId !== requestId) return
      this.setState({ orderLogoUrl: defaultLogoUrl })
    }
    img.src = shopLogoUrl
  }

  render() {
    const { authenticated } = this.props
    if(!authenticated) return (<Redirect to='/login' />)
    const { order } = this.props
    const { valid, note, show_bank, return_bank_account, return_address, validAcc, form_choose } = this.state
    if (form_choose === null) {
        return (
          <div className="formularz_ramka" style={{ textAlign: 'center', padding: '40px' }}>
            <div
              style={{
                background: '#fff',
                padding: '40px 60px 60px 60px',
                width: '25%',
                maxWidth: '600px',
                minWidth: '280px',
                margin: '0 auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px'
              }}
            >
              <h3 style={{ margin: '0 0 5px 0' }}>
                {intl.get('Co chcesz zrobić?')}
              </h3>

              <button
                style={{ width: '80%' }}
                onClick={() => this.setState({ form_choose: 'withdrawal' })}
              >
                {intl.get('Odstąpić od umowy')}
              </button>

              <button
                style={{ width: '80%' }}
                onClick={() => this.setState({ form_choose: 'rma' })}
              >
                {intl.get('Zgłosić reklamację')}
              </button>
            </div>
          </div>
        )
    }

    if (form_choose === 'withdrawal') {
        return (
          <div className="formularz">
            <style>{this.getOrderLogoStyle()}</style>
            <div>
              {order &&
                <div className="rma_order ramka">
                  <input type="hidden" name="order" value={order.id}/>
                  <h4>
                    {intl.get('Prosimy o wypełnienie poniższego formularza')}
                  </h4>
                  <div className="order_data row">
                    <div className="col-lg-6">
                      <h5>{intl.get('Dane klienta')}</h5>
                      <div className="f_group">
                        <label>{intl.get('Nazwa')}:</label>
                        <div>{order.delivery_name}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Ulica')}:</label>
                        <div>{order.delivery_street}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Miasto')}:</label>
                        <div>{order.delivery_city}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Kod pocztowy')}:</label>
                        <div>{order.delivery_zip}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('E-mail')}:</label>
                        <div>{order.delivery_email}</div>
                      </div>
                      {order.allegro_client_login &&
                        <div className="f_group">
                          <label>{intl.get('Login')}:</label>
                          <div>{order.allegro_client_login}</div>
                        </div>
                      }
                      {order.vat &&
                        <div className="f_group">
                          <label>{intl.get('NIP')}:</label>
                          <div>{order.vat}</div>
                        </div>
                      }
                    </div>
                    <div className="col-lg-6">
                      <h5>{intl.get('Dane zamówienia')}</h5>
                      <div className="f_group">
                        <label>{intl.get('Nr zamówienia')}:</label>
                        <div>{order.name}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Data zamówienia')}:</label>
                        <div>{order.date_order}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Data wysyłki')}:</label>
                        <div>{order.delivery_date}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Metoda dostawy')}:</label>
                        <div>{order.carrier}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Wartość zamówienia')}:</label>
                        <div>{order.amount_total}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Nr faktury VAT')}:</label>
                        <div>{order.invoice}</div>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <h5>{intl.get('Produkty')}</h5>
                  <div className="order_lines">
                    {order.lines.map((product, i) => this.getProductListItem(product, i, form_choose))}
                  </div>
                  <br/>
                    <>
                    <br/>
                    <h5>{intl.get('Dane o rachunku bankowym')}</h5>
                    <p className="bank_account_info">
                      {intl.get('Uzupełnienie danych rachunku bankowego jest opcjonalne. Jeśli pola pozostaną puste, środki zostaną zwrócone przy użyciu tej samej metody płatności, którą opłacono zamówienie.')}
                    </p>
                    <input
                      placeholder={intl.get('Nr rachunku')}
                      type="text"
                      name="return_bank_account"
                      value={return_bank_account}
                      onChange={this.handleChange}
                      className={(validAcc?'':'invalid') + (return_bank_account===''?' empty':'')}/>
                    <span className="redstar accInvalid hidden">{intl.get('Numer rachunku bankowego jest za krótki!')}</span>
                    {return_bank_account === '' &&
                      <span className="bank_account_warning">{intl.get('Uzupełnij numer rachunku bankowego, jeśli zwrot środków ma zostać wykonany przelewem.')}</span>
                    }
                    <textarea
                      placeholder={intl.get('Dane właściciela rachunku bankowego')}
                      className="note_area"
                      name="return_address"
                      value={return_address}
                      onChange={this.handleChange}/>
                    <br/>
                    </>
                </div>
              }
            </div>
            <div className="rma_header">
              <button className="pull-left secondary" onClick={this.logUserOut}>{intl.get('Anuluj')}</button>
              <button onClick={this.handleSubmit} className="pull-right" id="zatwierdz" disabled={!valid} >{intl.get('Potwierdź odstąpienie od umowy')}</button>
            </div>
          </div>
        )
     }

    if (form_choose === 'rma') {
        return (
          <div className="formularz">
            <style>{this.getOrderLogoStyle()}</style>
            <div>
              {order &&
                <div className="rma_order ramka">
                  <input type="hidden" name="order" value={order.id}/>
                  <h4>
                    {intl.get('Prosimy o wypełnienie poniższego formularza')}
                  </h4>
                  <div className="order_data row">
                    <div className="col-lg-6">
                      <h5>{intl.get('Dane klienta')}</h5>
                      <div className="f_group">
                        <label>{intl.get('Nazwa')}:</label>
                        <div>{order.delivery_name}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Ulica')}:</label>
                        <div>{order.delivery_street}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Miasto')}:</label>
                        <div>{order.delivery_city}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Kod pocztowy')}:</label>
                        <div>{order.delivery_zip}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('E-mail')}:</label>
                        <div>{order.delivery_email}</div>
                      </div>
                      {order.allegro_client_login &&
                        <div className="f_group">
                          <label>{intl.get('Login')}:</label>
                          <div>{order.allegro_client_login}</div>
                        </div>
                      }
                      {order.vat &&
                        <div className="f_group">
                          <label>{intl.get('NIP')}:</label>
                          <div>{order.vat}</div>
                        </div>
                      }
                    </div>
                    <div className="col-lg-6">
                      <h5>{intl.get('Dane zamówienia')}</h5>
                      <div className="f_group">
                        <label>{intl.get('Nr zamówienia')}:</label>
                        <div>{order.name}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Data zamówienia')}:</label>
                        <div>{order.date_order}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Data wysyłki')}:</label>
                        <div>{order.delivery_date}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Metoda dostawy')}:</label>
                        <div>{order.carrier}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Wartość zamówienia')}:</label>
                        <div>{order.amount_total}</div>
                      </div>
                      <div className="f_group">
                        <label>{intl.get('Nr faktury VAT')}:</label>
                        <div>{order.invoice}</div>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <h5>{intl.get('Produkty')}</h5>
                  <div className="order_lines">
                    {order.lines.map((product, i) => this.getProductListItem(product, i, form_choose))}
                  </div>
                  <br/>
                  <h5>{intl.get('Opis zgłoszenia')}</h5>
                  <textarea className="note_area" value={note} name="note" onChange={this.handleChange}/>
                  <br/>
                  { show_bank &&
                    <>
                    <br/>
                    <h5>{intl.get('Dane o rachunku bankowym')}</h5>
                    <input
                      placeholder={intl.get('Nr rachunku')}
                      type="text"
                      name="return_bank_account"
                      value={return_bank_account}
                      onChange={this.handleChange}
                      className={(validAcc?'':'invalid') + (return_bank_account===''?' empty':'')}/>
                    <span className="redstar accInvalid hidden">{intl.get('Numer rachunku bankowego jest za krótki!')}</span>
                    <textarea
                      placeholder={intl.get('Dane właściciela rachunku bankowego')}
                      className="note_area"
                      name="return_address"
                      value={return_address}
                      onChange={this.handleChange}/>
                    <br/>
                    </>
                  }
                  <br/>
                  <h5>{intl.get('Dodaj zdjęcia')}</h5>
                  <Images parent={this}/>
                  <br/>
                  <h5>{intl.get('Dodaj pliki')}</h5>
                  <Files parent={this}/>
                </div>
              }
            </div>
            <div className="rma_header">
              <button className="pull-left secondary" onClick={this.logUserOut}>{intl.get('Anuluj')}</button>
              <button onClick={this.handleSubmit} className="pull-right" id="zatwierdz" disabled={!valid} >{intl.get('Potwierdź i wyślij zgłoszenie')}</button>
            </div>
          </div>
        )
    }
  }
}
const Order = connect(mapStateToProps, mapDispatchToProps)(OrderComponent)
export default withRouter(Order)
